<template>
  <div ref="regalosRef" class="mesa-regalos-section">
    <h2 class="mesa-titulo animate-item">
      MESA DE<br />REGALOS
    </h2>
    <p class="mesa-descripcion animate-item">
      Su presencia en este día tan especial <br>
      es el mejor regalo que podríamos recibir. <br><br>

      Si deseas tener un detalle con nosotros, <br>
      te dejamos algunas opciones.
    </p>

    <!-- BOTÓN REGALOS -->
    <button @click="mostrarRegalos" class="btn-mesa animate-item">
      VER OPCIONES
    </button>

    <!-- SECCIÓN NO NIÑOS ELEGANTE (SIN BOTÓN / SIN MODAL) -->
    <div class="no-ninos-container animate-item">
      <div class="linea-divisoria-corta"></div>
      <p class="mesa-titulo">
       NO NIÑOS
      </p>
      <p class="mesa-descripcion">
        Amamos a los niños, pero hemos decidido que nuestra boda sea una celebración exclusivamente para adultos.<br>
¡Esperamos que puedan disfrutar de una noche especial junto a nosotros!      </p>
    </div>

    <!-- Línea ondulada decorativa roja lateral (Lado Izquierdo) -->
    <svg 
      class="linea-ondulada" 
      viewBox="0 0 100 800" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M 0,0 C 80,200 20,400 80,600 C 100,700 60,750 0,800" 
        fill="none" 
        stroke="#7A3D48 " 
        stroke-width="2.5"
        stroke-linecap="round"
      />
    </svg>

    <!-- OVERLAY MESA DE REGALOS -->
    <transition name="fade">
      <div v-if="overlayVisible" class="overlay" @click.self="cerrarOverlay">
        <div class="overlay-content" role="dialog" aria-modal="true">

          <h3 class="overlay-title">Opciones de regalo</h3>

          <div class="mesa-tarjeta">
            <img src="@/assets/SOBRE.avif" class="icono-sobre" />
            <p class="mesa-lugar">Sobrecito de Amor</p>
            <p class="mesa-numero">
              Pueden encontrar un sobre y un buzón en la recepción.
            </p>
          </div>

          <div class="linea-divisoria"></div>

          <div class="mesa-tarjeta">
            <p class="mesa-lugar">Datos Bancarios.</p>
            <p class="mesa-numero banco">Karla Jazmín Dado Castillo </p>
            <p class="mesa-numero1"> 
              <strong>Tarjeta: </strong> 4213 1661 7755 5376 <br>
              <strong> Cuenta:</strong> 65 23 99 08 98 <br>
              <strong>Clabe: </strong> 0218 1806 5239 9089 85
            </p>
          </div>

          <div class="linea-divisoria"></div>

          <button @click="cerrarOverlay" class="btn-cerrar">
            Regresar a la invitación
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'MesaRegalos',
  setup() {
    const regalosRef = ref(null)
    const overlayVisible = ref(false)
    const elementosAnimados = ref([])

    const mostrarRegalos = () => {
      overlayVisible.value = true
      document.body.style.overflow = 'hidden'
    }

    const cerrarOverlay = () => {
      overlayVisible.value = false
      document.body.style.overflow = 'auto'
    }

    onMounted(() => {
      nextTick(() => {
        elementosAnimados.value =
          regalosRef.value.querySelectorAll('.animate-item')

        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const index = [...elementosAnimados.value].indexOf(entry.target)
              gsap.fromTo(
                entry.target,
                { opacity: 0, y: 30 },
                {
                  opacity: 1,
                  y: 0,
                  duration: 0.5,
                  delay: index * 0.1,
                  ease: 'power2.out'
                }
              )
              observer.unobserve(entry.target)
            }
          })
        }, { threshold: 0.2 })

        elementosAnimados.value.forEach(el => observer.observe(el))
      })
    })

    return {
      regalosRef,
      overlayVisible,
      mostrarRegalos,
      cerrarOverlay
    }
  }
}
</script>

<style scoped>
.mesa-regalos-section {
  position: relative;
 background-color: #F4F1E9; ; 
  color: #1a1a1a;
  font-family: 'Playfair Display', serif;
  text-align: center;
  padding: 60px 20px;
  overflow: hidden;
}

/* Estilos de la línea ondulada en el lado izquierdo */
.linea-ondulada {
  position: absolute;
  top: 0;
  left: -5px;
  width: 80px;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}


.mesa-titulo {
  font-size: 26px;
  font-weight: normal;
  line-height: 1.4;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #1a1a1a;
  position: relative;
  z-index: 2;
}

.mesa-descripcion {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  line-height: 1.8;
  color: #444;
  padding: 0 20px 15px;
  margin-bottom: 25px;
  box-sizing: border-box;
  position: relative;
  z-index: 2;
}

.btn-mesa {
background: #686D55; color: #F4F1E9;   border: 1px solid #1a1a1a;
  padding: 8px 18px;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s ease;
  position: relative;
  z-index: 2;
}
.btn-mesa:hover { background: #686D55; color: #F4F1E9; }

/* ESTILOS PARA SECCIÓN NO NIÑOS EN TEXTO DIRECTO */
.no-ninos-container {
  margin-top: 40px;
  position: relative;
  z-index: 2;
}

.linea-divisoria-corta {
  width: 40px;
  height: 1px;
  background-color: #7A3D48 ;
  margin: 0 auto 25px;
}

.no-ninos-titulo {
  font-size: 15px;
  letter-spacing: 2px;
  margin-bottom: 12px;
  text-transform: uppercase;
  font-weight: 600;
  color: #1a1a1a;
}

.no-ninos-texto {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  line-height: 1.8;
  color: #555;
  max-width: 460px;
  margin: 0 auto;
    padding: 0 20px 15px;

  font-style: italic;
  padding: 0 10px;
}

/* Overlay */
.overlay {
  position: fixed; inset: 0;
  background: rgba(26, 26, 26, 0.9);
  display: flex; justify-content: center; align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
}
.overlay-content {
  background: #f9f6f1;
  color: #1a1a1a;
  border-radius: 12px;
  padding: 30px 20px;
  max-width: 420px; width: 100%;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  box-sizing: border-box;
  margin: auto;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
}
.overlay-title {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.mesa-tarjeta { margin-bottom: 20px; }
.mesa-lugar {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  margin-bottom: 6px;
}
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&display=swap');
.mesa-numero { font-size: 13px; letter-spacing: 0.5px; }
.mesa-numero1 {
  font-size: 15px !important;
font-family: 'Cinzel', serif;}
.mesa-numero.banco { letter-spacing: 1px; font-weight: 600;  font-size: 16px !important;
 }

.btn-cerrar {
  margin-top: 22px;
  background: none;
  border: 1px solid #1a1a1a;
  padding: 7px 16px;
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s ease;
}
.btn-cerrar:hover { background: #1a1a1a; color: #fff; }

/* Línea divisoria dentro del modal */
.linea-divisoria {
  width: 70%;
  height: 1px;
  background: linear-gradient(to right, transparent, #1a1a1a, transparent);
  margin: 26px auto;
}

/* Ícono del sobre */
.icono-sobre {
  width: 40px; height: 40px; object-fit: contain;
  margin-bottom: 10px;
  filter: invert(1) brightness(0.3);
}

.animate-item { opacity: 0; transform: translateY(40px); }

/* Transición overlay */
.fade-enter-active, .fade-leave-active { transition: opacity 0.4s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

@media (max-width: 600px) {
  .linea-ondulada { width: 50px; }
}
</style>